/**
 * Tile Display Labels
 *
 * Maps tile internal titles (lookup keys) to their display text.
 * For tiles displayed in compact spaces, we use abbreviated forms.
 */

export const getTileDisplayLabel = (title: string | undefined): string => {
  if (!title) return "";

  // Map internal titles to display labels
  const displayLabels: Record<string, string> = {
    Distance: "Proj. Distance",
  };

  return displayLabels[title] || title;
};
